import { InjectionToken } from '@angular/core';

import { CreateAppointmentModalType } from '@lib/core/models/create-appointment.interface';

export interface ChatNavigationHandlers {
  /**
   * Navigate to member guarantees page, opening it on a specific prescription
   * @param prescriptionId - ID of the specific prescription to open
   * @param userId - user ID to show guarantees for
   */
  navigateToPrescription?: (prescriptionId: string, userId: string) => void;

  /**
   * Switch to prescriptions tab in chat and highlight specific prescription (in-chat)
   * @param prescriptionId - ID of the specific prescription to highlight
   */
  switchToPrescriptionTab?: (prescriptionId: string) => void;

  /**
   * Open modal or navigate to create new prescription page
   */
  openCreatePrescriptionModal?: (userId: string) => void;

  /**
   * Arrange the delivery of a prescribed service named in the conversation. The host decides where
   * that happens — the guarantees tab opens on the line and raises the arrangement over it — so the
   * prescription is the part that matters here; the line itself says whether it is an appointment,
   * a lab order or a pharmacy one.
   * @param userId - user ID for the appointment
   * @param modalType - how the arrangement is meant to come about (ManualCreation or BindToExisting)
   * @param metadata - optional chat metadata for pre-filling fields, can include prescription object
   */
  openCreateAppointmentModal?: (
    userId: string,
    modalType: CreateAppointmentModalType,
    metadata?: {
      prescriptionId?: string;
      prescriptionIds?: string[];
      prescriptionName: string;
      partnerId?: string;
      locationId?: string;
      messageType?: 'appointment_request' | 'laboratory_request';
    }
  ) => void;

  /**
   * Navigate to member profile page
   */
  navigateToMemberProfile?: (userId: string) => void;
}

export const CHAT_NAVIGATION_HANDLERS = new InjectionToken<ChatNavigationHandlers>('ChatNavigationHandlers', {
  providedIn: 'root',
  factory: () => ({
    // Default empty handlers - host app should provide actual implementations
    navigateToPrescription: () => console.warn('navigateToPrescription handler not implemented'),
    switchToPrescriptionTab: () => console.warn('switchToPrescriptionTab handler not implemented'),
    openCreatePrescriptionModal: () => console.warn('openCreatePrescriptionModal handler not implemented'),
    openCreateAppointmentModal: () => console.warn('openCreateManualAppointmentModal handler not implemented'),
    navigateToMemberProfile: () => console.warn('navigateToMemberProfile handler not implemented'),
  }),
});
